var _path, _rect, _g, _rect2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Banking and secure communication") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 43 47-26 47 26Z",
    fill: "#45556D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 46,
    width: 86,
    height: 8,
    rx: 3,
    fill: "#B69782"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D7E0EB"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 58,
    width: 13,
    height: 39,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 58,
    width: 13,
    height: 39,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 58,
    width: 13,
    height: 39,
    rx: 3
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 98,
    width: 94,
    height: 10,
    rx: 4,
    fill: "#45556D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m119 62 24 9v17c0 14-12 22-24 27-12-5-24-13-24-27V71Z",
    fill: "#DEEEE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m108 87 8 8 15-17",
    stroke: "#357653",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureFinance);
export default __webpack_public_path__ + "static/media/feature-finance.f6056cc8c4b865040d742ec7176e4aee.svg";
export { ForwardRef as ReactComponent };